var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},_vm._l((_vm.questions),function(item){return _c('div',{key:item.question_id,staticClass:"wrap_question",on:{"click":function($event){return _vm.$router.push({
        path: '/helpcenter/question-answer',
        query: { id: _vm.$route.query.id, questionId: item.id },
      })}}},[_c('div',{staticClass:"wrap_question_circle"}),_vm._v(" "),_c('div',{staticClass:"wrap_question_text"},[_vm._v(_vm._s(item.title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }